/* ============================================================================
   popup.js — die Popup-Maschine: Bundles, Zubehoer, Geschenke,
   Objektiv-Leiste, Face-Scan, Filter-Schublade der Kollektion, Heldenseite
   ----------------------------------------------------------------------------
   Frueher assets/nko-popup.js (seit M6 umbenannt, Verhalten unveraendert).
   Ersetzt `popupApp` aus dem frueheren assets/app.js.

   WER DAS LAEDT
   ---------------------------------------------------------------------------
   Die Sections, die Popups rendern (R5): sections/product.liquid,
   sections/customizable-product-info.liquid, sections/main-collection.liquid
   (nur der Zweig mit Filter) und sections/page-family-template.liquid. Vorher
   luden es Gates im Kopf (snippets/head-assets.liquid) und am Ende des body
   (snippets/scripts.liquid). Der Browser fuehrt die Datei je URL nur einmal
   aus, doppelte Tags binden also nicht doppelt.

   DER VERTRAG, DEN DIESE DATEI EINHALTEN MUSS
   ---------------------------------------------------------------------------
   Fremde Stellen sprechen das Popup-System an, drei davon auf dem Weg in den
   Warenkorb:

     assets/accessories.js    theme.popupApp.open('accessories'), .clear()
     assets/bundles.js        theme.popupApp.open('bundle--' + id)
     assets/gifts.js          theme.popupApp.open('gift--' + id)
     assets/product.js        theme.popupApp.open('accessories')
     assets/configurator.js   theme.popupApp.open(...)

   Dazu der Ausloeser `[data-popup="{name}"]`, das Popup `.popup--{name}`, die
   Klassen `body.js-popup-show` und `.popup.is-shown`, auf die das
   Popup-Geruest stylt, `.js-close` zum Schliessen, und die Ereignisse
   `popupOpen:{name}` / `popupClose:{name}` auf `document.body`, auf die
   assets/face-scan-property.js und assets/face-scan.js hoeren. Alles bleibt.

   SEIT app.js WEG IST
   ---------------------------------------------------------------------------
   Hier standen drei Schutzbauten gegen app.js: ein `Object.defineProperty`,
   das Schreibversuche auf `theme.popupApp` verwarf, ein MutationObserver auf
   `body.class`, der Oeffnen und Schliessen „von wem auch immer“ bemerkte, und
   eine Klick-Delegation in der Capture-Phase mit `stopPropagation`, die
   fremde Hoerer an den Ausloesern aushebelte. app.js gibt es nicht mehr; der
   Beobachter lief trotzdem bei JEDER Klassenaenderung am <body>, und die
   Capture-Delegation blockierte Hoerer, die nichts mit app.js zu tun hatten.
   Jetzt: `open()`/`clear()` rufen `betrete()`/`verlasse()` direkt, die
   Delegation laeuft in der Bubble-Phase. Die Schnittstelle bleibt gleich.

   WAS DAS LEGACY NICHT KONNTE
   ---------------------------------------------------------------------------
   1. FOKUS. `center()` rief `.find("input[type=text]").first().focus()` auf.
      Auf der Produktseite gibt es NULL Textfelder — gezaehlt. Der Fokus blieb
      also auf dem Ausloeser HINTER der deckenden Blende. Wer mit der Tastatur
      arbeitet, stand im Nichts; wer einen Screenreader benutzt, bekam vom
      Popup gar nichts mit.
   2. ESCAPE. Gab es nicht — obwohl die Uebersetzung der Schliessen-Schaltflaeche
      seit jeher „Schließen (Esc)" lautet.
   3. FOKUS ZURUECK. Nach dem Schliessen landete der Fokus am Anfang des
      Dokuments statt auf dem Knopf, der das Popup geoeffnet hatte.
   4. `.popup__close` war ein `<div>` ohne Namen und ohne Tastaturzugang.
      Das ist jetzt im Markup ein `<button>` mit `aria-label`.
   ==========================================================================  */

const OFFEN = "js-popup-show";
const SICHTBAR = "is-shown";

const FOKUSSIERBAR = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
].join(",");

let aktiv = null; // das gerade offene `.popup`
let ausloeser = null; // Element, das den Fokus zurueckbekommt
let zaehler = 0;

/* ---------------------------------------------------------------- Oeffnen */

function finde(name) {
  return document.querySelector(`.popup--${CSS.escape(String(name))}`);
}

function open(name) {
  const el = finde(name);
  if (!el) return;
  if (document.body.classList.contains(OFFEN)) clear();
  el.classList.add(SICHTBAR);
  document.body.classList.add(OFFEN);
  aktiv = el;
  betrete(el);
}

function clear() {
  if (aktiv) {
    const war = aktiv;
    aktiv = null;
    verlasse(war);
  }
  document.body.classList.remove(OFFEN);
  for (const el of document.querySelectorAll(`.popup.${SICHTBAR}`)) {
    el.classList.remove(SICHTBAR);
  }
  // Aus dem Legacy uebernommen: Fehlermarkierungen im Popup zuruecksetzen.
  for (const el of document.querySelectorAll(".popup .error")) {
    el.classList.remove("error");
  }
}

/* ----------------------------------------------------------- Zustand */

/* Der Name, unter dem ein Popup geoeffnet wurde, wird aus dem Markup
   abgeleitet: der Ausloeser traegt ihn in `data-popup`, das Popup als Klasse
   `popup--{name}`. */
function nameVon(el) {
  for (const t of document.querySelectorAll("[data-popup]")) {
    const n = t.dataset.popup;
    if (n && el.classList.contains(`popup--${n}`)) return n;
  }
  return null;
}

function fenster(el) {
  return el.querySelector(".popup__inner");
}

function betrete(el) {
  const inner = fenster(el);
  if (!inner) return;

  /* Der Dialog ist das FENSTER, nicht die Blende: `.popup__layer` ist ein
     Geschwister von `.popup__inner` und gehoert nicht zum Dialog. */
  inner.setAttribute("role", "dialog");
  inner.setAttribute("aria-modal", "true");
  inner.setAttribute("tabindex", "-1");

  /* Der Dialog braucht einen Namen. Erste Wahl ist die Ueberschrift im Popup.
     Das Objektiv-Popup hat aber ein LEERES `.popup__title` — im Legacy wie
     hier, sein Text steckt im Inhalt. Dann tritt der Ausloeser ein: „Learn
     more" benennt den Dialog immer noch besser als gar nichts. */
  const titel = el.querySelector(".popup__title");
  const name = nameVon(el);

  /* Gegenstueck zu `popupClose:{name}` in verlasse(). assets/face-scan-property.js
     setzt darauf den Startschritt ("intro") und laedt beim ersten Mal
     assets/face-scan.js nach. */
  if (name) document.body.dispatchEvent(new CustomEvent(`popupOpen:${name}`));

  if (titel && titel.textContent.trim()) {
    if (!titel.id) titel.id = `nko-popup-titel-${++zaehler}`;
    inner.setAttribute("aria-labelledby", titel.id);
  } else if (name) {
    const auf = document.querySelector(`[data-popup="${CSS.escape(name)}"]`);
    const text = auf?.textContent.trim();
    if (text) inner.setAttribute("aria-label", text);
  }

  ausloeser = document.activeElement;

  /* Der Fokus geht auf das Fenster selbst, nicht auf das erste Bedienelement:
     so liest ein Screenreader zuerst den Titel vor, und die Reihenfolge beim
     Weitertabben beginnt sauber oben. Das setzt voraus, dass das Popup schon
     JETZT rendert: `content-visibility` darf beim Oeffnen nicht mit
     uebergeblendet werden (Popup-Geruest, `.popup.is-shown`), sonst geht
     der Fokus still ins Leere. */
  inner.focus({ preventScroll: true });
}

function verlasse(el) {
  const inner = fenster(el);
  inner?.removeAttribute("aria-modal");
  inner?.removeAttribute("role");
  inner?.removeAttribute("aria-label");

  const name = nameVon(el);
  if (name) {
    document.body.dispatchEvent(new CustomEvent(`popupClose:${name}`));
  }

  /* Der Fokus geht auf den Ausloeser zurueck — aber nur, wenn ihn nicht
     inzwischen jemand anders beansprucht hat.

     Massgeblich ist NICHT „steht der Fokus noch im Popup". Ein Klick auf die
     Blende schliesst das Popup und laesst den Fokus auf `<body>` zurueck; mit
     dieser Bedingung bliebe er dort liegen — gemessen. Ein Klick auf einen
     Link ausserhalb dagegen setzt den Fokus auf ein echtes Ziel, und das darf
     nicht zurueckgerissen werden. Der Unterschied ist also, ob der Fokus
     irgendwo GELANDET ist oder nur ins Leere gefallen. */
  const jetzt = document.activeElement;
  const gelandet = jetzt && jetzt !== document.body && !el.contains(jetzt);
  if (ausloeser && !gelandet) {
    ausloeser.focus?.({ preventScroll: true });
  }
  ausloeser = null;
}

/* ------------------------------------------------------------- Tastatur */

function sichtbareZiele(inner) {
  return [...inner.querySelectorAll(FOKUSSIERBAR)].filter(
    (e) => e.getClientRects().length > 0
  );
}

function falle(e) {
  const inner = aktiv && fenster(aktiv);
  if (!inner) return;

  const ziele = sichtbareZiele(inner);
  if (!ziele.length) {
    e.preventDefault();
    inner.focus({ preventScroll: true });
    return;
  }

  const erste = ziele[0];
  const letzte = ziele[ziele.length - 1];
  const hier = document.activeElement;

  if (e.shiftKey && (hier === erste || hier === inner)) {
    e.preventDefault();
    letzte.focus();
  } else if (!e.shiftKey && hier === letzte) {
    e.preventDefault();
    erste.focus();
  }
}

document.addEventListener("keydown", (e) => {
  if (!aktiv) return;
  if (e.key === "Escape") {
    e.preventDefault();
    clear();
  } else if (e.key === "Tab") {
    falle(e);
  }
});

/* --------------------------------------------------------------- Klicks */

/* Bubble-Phase, ohne `stopPropagation`: Hoerer an den Ausloesern selbst laufen
   zuerst und ungestoert. Die Capture-Phase war nur noetig, solange app.js
   eigene Handler an dieselben Ausloeser haengte. */
document.addEventListener(
  "click",
  (e) => {
    const zu = e.target.closest?.(".js-close");
    if (zu && zu.closest(".popup")) {
      /* WEDER preventDefault NOCH stopPropagation — beides war hier falsch und
         hat den Kaufweg im Bundle- und Geschenk-Popup lahmgelegt.

         `.js-close` sitzt naemlich nicht nur auf Schliessen-Elementen. In
         snippets/product-bundles.liquid (und -gifts) tragen es BEIDE
         Fussknoepfe:

           <div  class="btn … js-close js-bundle-save" data-save-bundle-id="…">
           <button class="btn … js-close" type="submit" form="AddToCartForm-…">

         `preventDefault()` verschluckte damit das Absenden des zweiten Knopfes,
         `stopPropagation()` verhinderte (damals in der Capture-Phase), dass der
         Klick den Knopf ueberhaupt erreicht — und damit auch den
         Bestaetigungs-Schalter, der `is-not-selected` aufhebt. Ohne den bleibt
         die Bundle-Gruppe unbestaetigt, und die Wache in assets/bundles.js
         blockiert JEDEN weiteren Absendeversuch.

         Schliessende Elemente brauchen ohnehin kein preventDefault: die Blende
         ist ein <div>, und `.popup__close` ist ein <button type="button">. */
      clear();
      return;
    }

    const auf = e.target.closest?.("[data-popup]");
    if (auf && finde(auf.dataset.popup)) {
      // Die Ausloeser sind teils `<a href="javascript:;">` — kein Sprung.
      e.preventDefault();
      open(auf.dataset.popup);
    }
  }
);

/* ------------------------------------------------------------ Schnittstelle */

window.theme = window.theme || {};

const schnittstelle = {
  open,
  clear,
  // Formgleichheit mit dem Legacy: `center` war dort das Oeffnen ohne das
  // Schliessen des vorherigen Popups, `close` haengte nur Handler an.
  center: open,
  close: () => {},
};

window.theme.popupApp = schnittstelle;

/* ----------------------------------------------------------------------------
   NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`.
   Der Modulbereich haelt die Namen oben lokal: als klassisches Skript
   ueberschriebe `open` hier `window.open`, und `FOKUSSIERBAR` stiesse sich an
   assets/cart-drawer.js. Module laufen wie `defer` nach dem Parsen in
   Dokumentreihenfolge, aber nur einmal je URL und im strict mode.
   ---------------------------------------------------------------------------- */
